import React, { useEffect } from "react";
import styles from "./BankUpdationCompleted.module.scss";
import DoneImage from "../../Components/assets/Images/congratsdoneimage.svg";

function BankUpdationCompleted() {
  useEffect(() => {
    sessionStorage.removeItem("reqId");
  }, []);
  return (
    <div className={styles.mainWrapperTop}>
      <div className={styles.wrapper}>
        <div className={styles.step}>
          <img src={DoneImage} />
        </div>
        <div className={styles.leftContainer}>
          <div className={styles.headerSection}>
            <p className={styles.signup}>Thanks For Submitting Request!</p>
            <div className={styles.textdiv}>
              <p className={styles.instructiontext}>
                The requested modification has been successfully completed. You
                will receive a confirmation email shortly with all the details.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BankUpdationCompleted;
